var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "digital-mailbox-email-list" },
    [
      _c("csp-digital-mailbox-email-list-table", {
        ref: "emailListTable",
        attrs: {
          "items-ajax-url": _vm.itemsAjaxUrl,
          "table-headline": "Digitale Mailbox",
          "updating-email-id": _vm.updatingEmailId,
        },
        on: {
          "row-clicked": _vm.onRowClicked,
          "row-contextmenu": _vm.onRowContextmenu,
        },
        scopedSlots: _vm._u([
          {
            key: "above-body",
            fn: function () {
              return [
                _c(
                  "div",
                  { staticClass: "py-2 d-flex align-items-center" },
                  [
                    _c(
                      "b-button-group",
                      [
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant:
                                _vm.mailType === "received"
                                  ? "primary"
                                  : "secondary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setMailType("received")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Posteingang\n                    "
                            ),
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "b-button",
                          {
                            attrs: {
                              variant:
                                _vm.mailType === "sent"
                                  ? "primary"
                                  : "secondary",
                            },
                            on: {
                              click: function ($event) {
                                return _vm.setMailType("sent")
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n                        Postausgang\n                    "
                            ),
                          ]
                        ),
                      ],
                      1
                    ),
                    _vm._v(" "),
                    _c("csp-form-select-searchable", {
                      staticClass: "ml-3 digital-mailbox-mailbox-select",
                      attrs: {
                        options: _vm.mailboxOptions,
                        value: _vm.entraAppMailboxId,
                      },
                      on: { change: _vm.onMailboxChange },
                    }),
                  ],
                  1
                ),
              ]
            },
            proxy: true,
          },
          {
            key: "cell(actions)",
            fn: function ({ data }) {
              return [
                _c("div", { staticClass: "table-actions" }, [
                  data.actions.conversationEmailCount > 1
                    ? _c(
                        "a",
                        {
                          attrs: { title: "Konversation anzeigen" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openConversationModal(
                                data.actions.conversationId
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "inticon-comment" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  data.actions.attachmentCount
                    ? _c(
                        "a",
                        {
                          attrs: { title: "Anhänge anzeigen" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openAttachmentModal(
                                data.actions.emailId
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "inticon-autoclaim_files" })]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  data.rowMeta.canAssignDamageRecordAppraisal
                    ? _c(
                        "a",
                        {
                          attrs: { title: "Gutachten zuordnen" },
                          on: {
                            click: function ($event) {
                              $event.stopPropagation()
                              return _vm.openAssignModal(
                                data.actions.emailId,
                                data.actions.subject
                              )
                            },
                          },
                        },
                        [_c("i", { staticClass: "inticon-autoclaim_assign" })]
                      )
                    : _vm._e(),
                ]),
              ]
            },
          },
        ]),
      }),
      _vm._v(" "),
      _c("csp-context-menu", {
        ref: "contextMenu",
        attrs: { items: _vm.contextMenuItems },
        on: { select: _vm.onContextMenuSelect },
      }),
      _vm._v(" "),
      _c("csp-email-category-edit-modal", {
        attrs: {
          "email-id": _vm.selectedEmailId,
          "show-modal": _vm.showCategoryModal,
        },
        on: {
          "categories-changed": _vm.onCategoriesChanged,
          "update:showModal": _vm.onCategoryModalVisibilityChange,
        },
      }),
      _vm._v(" "),
      _c("csp-email-damage-record-assign-modal", {
        attrs: {
          "email-id": _vm.selectedEmailId,
          "show-modal": _vm.showAssignModal,
          subject: _vm.selectedSubject,
        },
        on: {
          "assignments-changed": _vm.onAssignmentsChanged,
          "update:showModal": _vm.onAssignModalVisibilityChange,
        },
      }),
      _vm._v(" "),
      _c("csp-email-set-reminder-modal", {
        attrs: { show: _vm.showReminderModal },
        on: { cancel: _vm.onReminderCancel, confirm: _vm.onReminderConfirm },
      }),
      _vm._v(" "),
      _c("csp-email-user-assignment-modal", {
        attrs: {
          "email-id": _vm.contextMenuTargetRow
            ? _vm.contextMenuTargetRow.rowMeta.emailId
            : null,
          "initial-user-id": _vm.contextMenuTargetRow
            ? _vm.contextMenuTargetRow.rowMeta.assignedToUserId
            : null,
          show: _vm.showUserAssignmentModal,
        },
        on: {
          cancel: _vm.onUserAssignmentCancel,
          confirm: _vm.onUserAssignmentConfirm,
        },
      }),
      _vm._v(" "),
      _c("csp-email-conversation-modal", {
        attrs: {
          "conversation-id": _vm.selectedConversationId,
          show: _vm.showConversationModal,
        },
        on: {
          hidden: _vm.onConversationModalHidden,
          "open-email": _vm.onConversationModalOpenEmail,
        },
      }),
      _vm._v(" "),
      _c("csp-email-attachment-modal", {
        attrs: {
          "email-id": _vm.attachmentModalEmailId,
          show: _vm.showAttachmentModal,
        },
        on: { hidden: _vm.onAttachmentModalHidden },
      }),
      _vm._v(" "),
      _c("csp-email-detail-modal", {
        attrs: {
          "form-context": _vm.detailModalFormContext,
          show: _vm.showDetailModal,
        },
        on: {
          "email-updated": _vm.onDetailModalEmailUpdated,
          hidden: _vm.onDetailModalHidden,
        },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }